document.addEventListener('DOMContentLoaded', function () {
  const rewardSliderCallBack = (e) => {
    e.stopPropagation();
    e.preventDefault();
    e.target.classList.toggle('extended');
    document.querySelector('.loyaltylion-redemption-widget-rewards')?.classList.toggle('hidden');
    document.querySelector('.js-redeem-rewards-slider-toggle-span')?.classList.toggle('r-180-deg');
    const cartForwardArrow = document.querySelector('.loyaltylion-redemption-widget-container__cart-items .lion-in-cart-rewards-widget__navigator--forward')
    const cartBackArrow = document.querySelector('.loyaltylion-redemption-widget-container__cart-items .lion-in-cart-rewards-widget__navigator--back')

    const disabledButtons = document.querySelectorAll('#loyaltylion .lion-action-button.lion-in-cart-reward__button.lion-action-button--disabled')
    let ll_cart_line_item = null,
    ll_cart_line_item_points = 0,
    ll_cart_line_item_more_points = 0

    if(disabledButtons.length) {
      disabledButtons.forEach(item => {
        ll_cart_line_item = item.closest('.lion-in-cart-rewards-widget-item')
        ll_cart_line_item_points = Number(ll_cart_line_item.querySelector('.lion-in-cart-rewards-widget-item__cost').textContent.split(' ')[0].replace(',', '')) || 1
        ll_cart_line_item_more_points = Number(item.textContent.replace('You need', '').replace('more points', '').trim().replace(',', '')) || 1
        item.style.setProperty('--ll-more-points-progress',`${(1 - ll_cart_line_item_more_points / ll_cart_line_item_points) * 100}%`);
        item.innerHTML = window.ll_custom_message.need_points
      })
    }

    if (cartForwardArrow) {
      cartForwardArrow.innerHTML = `<svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="1.06068" height="7.42477" transform="matrix(-0.707107 0.707107 0.707107 0.707107 0.75 0)" fill="black"/>
      <rect width="1.06068" height="7.42477" transform="matrix(0.707107 0.707107 0.707107 -0.707107 0 9.75)" fill="black"/>
      </svg>`
    }
    
    if (cartBackArrow) {
      cartBackArrow.innerHTML = `<svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5.25" width="1.06068" height="7.42477" transform="rotate(45 5.25 0)" fill="black"/>
        <rect x="6" y="9.75" width="1.06068" height="7.42477" transform="rotate(135 6 9.75)" fill="black"/>
        </svg>`
    }

    const slider = document.querySelector('.lion-in-cart-rewards-widget__rewards-slider')
    
    let itemCount = slider.childElementCount
    let dividedItemCount = itemCount / 2
    let floor = Math.floor(dividedItemCount)
    let counter = 1

    if (screen.width > 600 && cartForwardArrow && cartBackArrow) {
      cartForwardArrow.addEventListener("click", cartForwardArrowClick);
      cartBackArrow.addEventListener("click", cartBackArrowClick);

      function cartForwardArrowClick() {
        if (counter + 1 == floor || counter == floor) {
          cartForwardArrow.style.visibility = 'hidden';
        }
        if (counter < floor) {
          counter++;
        }
      }

      function cartBackArrowClick() {
        counter--;
        cartForwardArrow.style.visibility = 'visible'
      }
    }
  }

  [...document.querySelectorAll('.js-redeem-rewards-slider-toggle')]?.forEach(function(button) {
    button.addEventListener('click', rewardSliderCallBack);
  });
})
